<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.$parent.rerender"
  >
    <fieldset
      :disabled="isResumeCoordinated"
      style="border: 0; padding: 0; margin: 0;"
    >
    <div class="content-title content-mb-14">
      {{ stepNumber(16) }}. Бюджет проекта в части расходования средств займа
      Фонда, тыс. руб.
    </div>
    <div class="row myrow content-mb-42">
      <div class="col-xs-12 mycol">
        <table
          class="c-indicator c-indicator-w-100 table-top-bd"
          v-scroll="handleScroll"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th style="width: 80px;">
                № <br />
                п/п
              </th>
              <th style="width: 525px;">
                Направления целевого использования средств
              </th>
              <th>
                Зарплата сотрудников, вкл. налоги и взносы от ФОТ
              </th>
              <th>
                Работы и услуги, выполняемые третьими лицами, приобретение прав
              </th>
              <th>Материалы и комплектующие</th>
              <th>Приобретение оборудования</th>
              <th>Итого</th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(articles, index) in project.BUDGET.BUDGET_ARTICLE_ID"
            >
              <tr v-if="articles.length > 1" v-bind:key="index">
                <td>{{ budgetIndex(index) }}</td>
                <td>
                  {{ articles[0].UF_BUDGET_ARTICLE_SECTION_NAME }}
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_ZARPLATA_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_JOB_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_MATERIAL_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_OBORUD_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_ITOGO_ZAIM") | toCurrency
                  }}</strong>
                </td>
              </tr>
              <tr
                v-for="(article, articleIndex) in articles"
                v-bind:value="article.UF_BUDGET_ARTICLE_ID"
                v-bind:key="article.UF_BUDGET_ARTICLE_ID"
              >
                <td v-if="articles.length === 1">{{ budgetIndex(index) }}</td>
                <td v-else>{{ budgetIndex(index) }}.{{ articleIndex + 1 }}</td>
                <td v-html="article.UF_BUDGET_ARTICLE_NAME"></td>

                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ZARPLATA_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_ZARPLATA_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_ZARPLATA_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-show="false"
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ZARPLATA_SOFIN'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_ZARPLATA_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_ZARPLATA_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_JOB_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_JOB_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_JOB_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-show="false"
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_JOB_SOFIN'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_JOB_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_JOB_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_MATERIAL_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_MATERIAL_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_MATERIAL_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-show="false"
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_MATERIAL_SOFIN'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_MATERIAL_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_MATERIAL_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_OBORUD_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_OBORUD_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_OBORUD_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-show="false"
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_OBORUD_SOFIN'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_OBORUD_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      article.IS_OBORUD_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ITOGO_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="
                      calcBudgetRowZaim(article.UF_BUDGET_ARTICLE_ID)
                    "
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
                <td
                  v-show="false"
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ITOGO_SOFIN'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="
                      calcBudgetRowSofin(article.UF_BUDGET_ARTICLE_ID)
                    "
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
              </tr>
            </template>
            <tr class="tr-foot-itog">
              <td colspan="2" class="pd-col-62">ИТОГО</td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ZARPLATA_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ZARPLATA_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_JOB_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_JOB_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_MATERIAL_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_MATERIAL_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_OBORUD_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_OBORUD_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ITOGO_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ITOGO_SOFIN') | toCurrency"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row myrow content-mb-42">
      <div class="col-xs-12 mycol">
        <div class="h3-tab-title">
          В том числе распределение по годам, тыс. руб.
        </div>
        <table
          class="c-indicator content-mb-25  table-top-bd"
          v-scroll="handleScroll"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th style="width: 240px;">Год</th>
              <th style="width: 367px;"></th>
              <th>
                Зарплата сотрудников, вкл. налоги и взносы от ФОТ
              </th>
              <th>
                Работы и услуги, выполняемые третьими лицами, приобретение прав
              </th>
              <th>Материалы и комплектующие</th>
              <th>Приобретение оборудования</th>
              <th>Итого</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="year in budgetYears">
              <tr v-bind:key="year">
                <td>{{ year }}</td>
                <td></td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_ZARPLATA_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_ZARPLATA_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td v-show="false">
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_ZARPLATA_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_ZARPLATA_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_JOB_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_JOB_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td v-show="false">
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_JOB_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_JOB_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_MATERIAL_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_MATERIAL_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td v-show="false">
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_MATERIAL_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_MATERIAL_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_OBORUD_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_OBORUD_ZAIM_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td v-show="false">
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-model="project.BUDGET_YEAR.items[year][0].UF_OBORUD_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_OBORUD_SOFIN_BLOCK === 1 ||
                        $parent.$parent.projectDisabled
                    "
                  />
                </td>
                <td>
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="calcBudgetYearsRowZaim(year, 0)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
                <td v-show="false">
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-bind:value="calcBudgetYearsRowSofin(year, 0)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
              </tr>
            </template>
            <tr class="tr-foot-itog">
              <td class="pd-col-62">ИТОГО</td>
              <td></td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ZARPLATA_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ZARPLATA_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_JOB_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_JOB_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_MATERIAL_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_MATERIAL_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_OBORUD_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_OBORUD_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ITOGO_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ITOGO_SOFIN') | toCurrency"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="content-title">
      {{ stepNumber(17) }}. Источники финансирования проекта, включая стадию
      серийного промышленного производства
    </div>

    <div class="row myrow content-mb-42">
      <div class="col-xs-12 mycol">
        <table class="c-indicator content-mb-25 c-indicator-w-100">
          <thead>
            <tr>
              <th class="tab-wid-250 al-text" rowspan="2">
                Форма финансирования
              </th>
              <th colspan="4">
                Расходы по Проекту, произведенные до заключения договора займа
              </th>
              <th colspan="2">
                Обязательства по софинансированию Проекта, после заключения
                Договора
              </th>
              <th></th>
            </tr>
            <tr>
              <th class="tab-wid-122">{{ year() - 2 }}</th>
              <th class="tab-wid-122">{{ year() - 1 }}</th>
              <th class="tab-wid-122">{{ year() }}</th>
              <th class="tab-wid-122">Итого</th>
              <th class="tab-wid-122">Всего</th>
              <th class="tab-wid-250">
                В том числе не позднее 6 месяцев с даты заключения Договора
              </th>
              <th class="tab-wid-250">Всего софинансирования по проекту</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="dc in directory.tree_vid_financing_other_sources">
              <template v-for="child in dc.CHILD" v-if="inSourceList(child.ID)">
                <tr
                  v-bind:key="index"
                  v-for="(item, index) in project.OTHER_SOURCE_FINANCE.items_v3"
                  v-if="
                    item.UF_OTHER_SOURCE_ID === child.ID &&
                      child.CODE !== 'all_sofinance_v3' &&
                      child.CODE !== 'investor_v3' &&
                      child.CODE !== 'investor_not_last_2year_v3'
                  "
                >
                  <td>
                    {{ child.NAME }}
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_LAST2_YEAR'
                      )
                    }"
                  >
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-if="child.CODE !== 'fond' && child.CODE !== 'regfond'"
                      v-model="item.UF_LAST2_YEAR"
                      type="text"
                      class="i-main-style"
                      @keypress="isNumber(item.UF_LAST2_YEAR)"
                      :disabled="$parent.$parent.projectDisabled"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_LAST_YEAR'
                      )
                    }"
                  >
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-if="child.CODE !== 'fond' && child.CODE !== 'regfond'"
                      v-model="item.UF_LAST_YEAR"
                      type="text"
                      class="i-main-style"
                      @keypress="isNumber($event)"
                      :disabled="$parent.$parent.projectDisabled"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_CURRENT_YEAR'
                      )
                    }"
                  >
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-if="child.CODE !== 'fond' && child.CODE !== 'regfond'"
                      v-model="item.UF_CURRENT_YEAR"
                      type="text"
                      class="i-main-style"
                      @keypress="isNumber($event)"
                      :disabled="$parent.$parent.projectDisabled"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_ALL_YEAR'
                      )
                    }"
                  >
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-if="child.CODE !== 'fond' && child.CODE !== 'regfond'"
                      :value="calcSumAllYear(item)"
                      disabled
                      type="text"
                      class="i-main-style"
                      @keypress="isNumber($event)"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_SOFINANCE_ALL'
                      )
                    }"
                  >
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-if="child.CODE !== 'fond' && child.CODE !== 'regfond'"
                      v-model="item.UF_SOFINANCE_ALL"
                      type="text"
                      class="i-main-style"
                      @keypress="isNumber($event)"
                      :disabled="$parent.$parent.projectDisabled"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error':
                        hasOtherSourceFinanceError(
                          index,
                          'UF_SOFINANCE_6MONTHS'
                        ) || item.UF_SOFINANCE_6MONTHS > item.UF_SOFINANCE_ALL
                    }"
                  >
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-if="child.CODE !== 'fond' && child.CODE !== 'regfond'"
                      v-model="item.UF_SOFINANCE_6MONTHS"
                      type="text"
                      class="i-main-style"
                      @keypress="isNumber($event)"
                      :disabled="$parent.$parent.projectDisabled"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_ALL_YEAR'
                      )
                    }"
                  >
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-if="child.CODE === 'fond'"
                      :disabled="
                        child.CODE === 'fond' || $parent.$parent.projectDisabled
                      "
                      v-on:keypress="isNumber($event)"
                      :value="calcSourceFondValue()"
                      type="text"
                      class="i-main-style"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-else-if="child.CODE === 'regfond'"
                      v-model="item.UF_SUM_ALL"
                      :disabled="
                        child.CODE === 'fond' || $parent.$parent.projectDisabled
                      "
                      v-on:keypress="isNumber($event)"
                      type="text"
                      class="i-main-style"
                      @change="removeOtherSourceFinanceError(index)"
                    />
                    <vue-numeric
                      separator="space"
                      output-type="Number"
                      v-else
                      v-on:keypress="isNumber($event)"
                      type="text"
                      class="i-main-style"
                      :value="calcSumSofinance(item)"
                      disabled
                      @change="removeOtherSourceFinanceError(index)"
                    />
                  </td>
                </tr>
                <tr
                  v-bind:key="index"
                  v-for="(item, index) in project.OTHER_SOURCE_FINANCE.items_v3"
                  v-if="
                    item.UF_OTHER_SOURCE_ID === child.ID &&
                      child.CODE === 'all_sofinance_v3'
                  "
                >
                  <td>
                    {{ child.NAME }}
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_LAST2_YEAR'
                      )
                    }"
                  >
                    <input
                      :value="calcAllSumSofinance().UF_LAST2_YEAR | toCurrency"
                      type="text"
                      class="i-main-style"
                      :disabled="true"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_LAST_YEAR'
                      )
                    }"
                  >
                    <input
                      :value="calcAllSumSofinance().UF_LAST_YEAR | toCurrency"
                      type="text"
                      class="i-main-style"
                      :disabled="true"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_CURRENT_YEAR'
                      )
                    }"
                  >
                    <input
                      :value="
                        calcAllSumSofinance().UF_CURRENT_YEAR | toCurrency
                      "
                      type="text"
                      class="i-main-style"
                      :disabled="true"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_ALL_YEAR'
                      )
                    }"
                  >
                    <input
                      :value="calcAllSumSofinance().UF_ALL_YEAR | toCurrency"
                      disabled
                      type="text"
                      class="i-main-style"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_SOFINANCE_ALL'
                      )
                    }"
                  >
                    <input
                      :value="
                        calcAllSumSofinance().UF_SOFINANCE_ALL | toCurrency
                      "
                      type="text"
                      class="i-main-style"
                      :disabled="true"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error':
                        hasOtherSourceFinanceError(
                          index,
                          'UF_SOFINANCE_6MONTHS'
                        ) || item.UF_SOFINANCE_6MONTHS > item.UF_SOFINANCE_ALL
                    }"
                  >
                    <input
                      :value="
                        calcAllSumSofinance().UF_SOFINANCE_6MONTHS | toCurrency
                      "
                      type="text"
                      class="i-main-style"
                      :disabled="true"
                    />
                  </td>
                  <td
                    v-bind:class="{
                      'has-error': hasOtherSourceFinanceError(
                        index,
                        'UF_SUM_ALL'
                      )
                    }"
                  >
                    <input
                      :value="calcAllSumSofinance().UF_SUM_ALL | toCurrency"
                      type="text"
                      class="i-main-style"
                      disabled
                    />
                  </td>
                </tr>
              </template>
            </template>
            <tr class="tr-foot-itog">
              <td colspan="7" class="pd-col-62">ИТОГО</td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcSourceSum() | toCurrency"
                  :disabled="$parent.$parent.projectDisabled"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row myrow content-mb-42">
      <div class="col-xs-12 mycol">
        <form action="#">
          <textarea
            :disabled="$parent.$parent.projectDisabled"
            name=""
            id=""
            class="i-main-style t-dop-style  i-wid-50"
            placeholder="Укажите программу поддержки, в рамках которой получены бюджетные средства, вид поддержки (субсидия, льготный займ и т.п.), а также объем уже израсходованных средств"
          ></textarea>
        </form>
      </div>
    </div>
    </fieldset>
  </div>
  <!--container-fluid-->
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import { FETCH_DIRECTORIES, FETCH_DIRECTORY } from "@/store/actions.type";
import Bank_guarantee from "@/components/project/form/partial/BankGuarantee";

export default {
  name: "Budget3",
  components: { Bank_guarantee },
  props: ["step", "project"],

  data() {
    return {
      loaded: false,
      h16tooltipShow: false,
      h16tooltip:
        "<img src='https://lkbe.frprf.ru//images/project/p15_info.png' />"
    };
  },
  async mounted() {
    await this.$store
      .dispatch(FETCH_DIRECTORIES, [
        "program_fin_support",
        "status_all",
        "status"
      ])
      .then(() => {
        this.$nextTick(this.initializeBudgetData);
      });
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["tree/vid_financing_other_sources"])
      .then(() => {
        this.directory.tree_vid_financing_other_sources[1].CHILD.forEach(
          function(s) {
            let ss = 0;
            if (s.CODE === "regfond") {
              this.project.OTHER_SOURCE_FINANCE.items_v3.forEach(function(
                item
              ) {
                if (s.ID === item.UF_OTHER_SOURCE_ID) {
                  ss = item.UF_VALUE;
                }
              },
              this);
            }
            this.calcSourceFondValue(ss);
          },
          this
        );
      }, this);
  },
  watch: {
    project: {
      handler() {
        this.initializeBudgetData();
      },
      deep: true
    }
  },
  methods: {
    initializeBudgetData() {
      if (this.project && this.project.BUDGET) {
        if (this.project.BUDGET.items.length === 0) {
          this.project.BUDGET.items = new Object();
        }

        for (let articles in this.project.BUDGET.BUDGET_ARTICLE_ID) {
          this.project.BUDGET.BUDGET_ARTICLE_ID[articles].forEach(function(
            item
          ) {
            if (
              typeof this.project.BUDGET.items[item.UF_BUDGET_ARTICLE_ID] ===
              "undefined"
            ) {
              Vue.set(this.project.BUDGET.items, item.UF_BUDGET_ARTICLE_ID, {
                ID: 0,
                UF_BUDGET_ARTICLE_ID: item.UF_BUDGET_ARTICLE_ID,
                UF_ITOGO_SOFIN: 0,
                UF_ITOGO_ZAIM: 0,
                UF_JOB_SOFIN: 0,
                UF_JOB_ZAIM: 0,
                UF_MATERIAL_SOFIN: 0,
                UF_MATERIAL_ZAIM: 0,
                UF_OBORUD_SOFIN: 0,
                UF_OBORUD_ZAIM: 0,
                UF_PROJECT_ID: this.project.ID,
                UF_ZARPLATA_SOFIN: 0,
                UF_ZARPLATA_ZAIM: 0
              });
            }
          },
          this);
        }
        if (
          this.project.BUDGET_YEAR.items[this.project.BUDGET_YEAR.YearTwoLine]
            .length < 2
        ) {
          Vue.set(
            this.project.BUDGET_YEAR.items[
              this.project.BUDGET_YEAR.YearTwoLine
            ],
            1,
            {
              UF_IS_ALREADY: 0,
              UF_ITOGO_SOFIN: 0,
              UF_ITOGO_ZAIM: 0,
              UF_JOB_SOFIN: 0,
              UF_JOB_ZAIM: 0,
              UF_MATERIAL_SOFIN: 0,
              UF_MATERIAL_ZAIM: 0,
              UF_OBORUD_SOFIN: 0,
              UF_OBORUD_ZAIM: 0,
              UF_PROJECT_ID: this.project.ID,
              UF_YEAR: this.project.BUDGET_YEAR.YearTwoLine,
              UF_ZARPLATA_SOFIN: 0,
              UF_ZARPLATA_ZAIM: 0
            }
          );
        }

        this.project.OTHER_SOURCE_FINANCE.UF_OTHER_SOURCE_ID.forEach(function(
          sourceId
        ) {
          let n = false;
          this.project.OTHER_SOURCE_FINANCE.items_v3.forEach(function(item) {
            if (sourceId === item.UF_OTHER_SOURCE_ID) {
              n = true;
            }
          }, this);
          if (!n) {
            this.project.OTHER_SOURCE_FINANCE.items_v3.push({
              UF_OTHER_SOURCE_ID: sourceId,
              UF_PROJECT_ID: this.project.ID,
              UF_LAST2_YEAR: "",
              UF_LAST_YEAR: "",
              UF_CURRENT_YEAR: "",
              UF_SOFINANCE_ALL: "",
              UF_SOFINANCE_6MONTHS: "",
              UF_SUM_ALL: ""
            });
          }
        },
        this);
      }
      this.loaded = true;
    },
    stepNumber(num) {
      let steps = {
        16: 16,
        17: 17
      };

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "konversia" &&
        this.project.UF_VERSION > 2
      ) {
        steps = {
          16: 15,
          17: 16
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
          "complectyushie" ||
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
          "complectyushie_rfrp"
      ) {
        steps = {
          16: 18,
          17: 19
        };
      }
      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "cifrovizaciya"
      ) {
        steps = {
          16: 20,
          17: 21
        };
      }
      if (this.programCode(this.project.UF_SUPPORT_PROG_ID) === "lekarstva") {
        if (this.project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1) {
          steps = {
            16: 14,
            17: 15
          };
        } else {
          steps = {
            16: 13,
            17: 14
          };
        }
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "working_rfrp"
      ) {
        steps = {
          16: 18,
          17: 19
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "priority_program"
      ) {
        steps = {
          16: 25,
          17: 26
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "evolution" &&
        this.project.UF_VERSION < 3
      ) {
        steps = {
          16: 17,
          17: 18
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "evolution" &&
        this.project.UF_VERSION > 2
      ) {
        steps = {
          16: 17,
          17: 18
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "regfond" &&
        this.project.UF_VERSION > 2
      ) {
        steps = {
          16: 18,
          17: 19
        };
      }

      if (this.programCode(this.project.UF_SUPPORT_PROG_ID) === "working") {
        steps = {
          16: 19,
          17: 20
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "auto_components"
      ) {
        steps = {
          16: 18,
          17: 19
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) ===
        "improving_ecology"
      ) {
        steps = {
          16: 17,
          17: 18
        };
      }

      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "stankostroi" ||
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "konversia"
      ) {
        steps = {
          16: 17,
          17: 18
        };
      }

      return steps[num] + (this.project.UF_SETTING && this.project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1 ? 1 : 0);
    },
    findRussia() {
      let id = 0;

      this.directory.country.forEach(function(country) {
        if (country.CODE == "ru") {
          id = country.ID;
        }
      });

      return id;
    },
    calcSourceFondValue() {
      let sum = 0;
      this.directory.tree_vid_financing_other_sources[1].CHILD.forEach(function(
        s
      ) {
        if (s.CODE === "fond") {
          this.project.OTHER_SOURCE_FINANCE.items_v3.forEach(function(item) {
            if (s.ID === item.UF_OTHER_SOURCE_ID) {
              sum = this.project.UF_SUM_REQUEST;
              //item.UF_SUM_ALL = sum;
              //if (item.UF_VALUE < 0) item.UF_VALUE = 0;
            }
          }, this);
        }
      },
      this);
      this.directory.tree_vid_financing_other_sources[1].CHILD.forEach(function(
        s
      ) {
        if (s.CODE === "regfond") {
          this.project.OTHER_SOURCE_FINANCE.items_v3.forEach(function(item) {
            if (s.ID === item.UF_OTHER_SOURCE_ID) {
              sum = sum - item.UF_SUM_ALL;
              if (sum < 0) {
                item.UF_SUM_ALL = this.project.UF_SUM_REQUEST;
                sum = 0;
              }
            }
          }, this);
        }
      },
      this);
      this.directory.tree_vid_financing_other_sources[1].CHILD.forEach(function(
        s
      ) {
        if (s.CODE === "fond") {
          this.project.OTHER_SOURCE_FINANCE.items_v3.forEach(function(item) {
            if (s.ID === item.UF_OTHER_SOURCE_ID) {
              item.UF_SUM_ALL = sum;
            }
          }, this);
        }
      },
      this);
      return sum;
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID === id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    },
    hasBudgetError(id, field) {
      if (typeof this.$parent.$parent.budgetErrors[id] !== "undefined") {
        if (
          typeof this.$parent.$parent.budgetErrors[id][field] !== "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    removeBudgetError(id) {
      if (typeof this.$parent.$parent.budgetErrors[id] !== "undefined") {
        Vue.delete(this.$parent.$parent.budgetErrors, id);
      }
      return false;
    },
    calcBudgetRowZaim(item) {
      let i = this.project.BUDGET.items[item];
      if (i.UF_ZARPLATA_ZAIM === "") i.UF_ZARPLATA_ZAIM = 0;
      if (i.UF_JOB_ZAIM === "") i.UF_JOB_ZAIM = 0;
      if (i.UF_MATERIAL_ZAIM === "") i.UF_MATERIAL_ZAIM = 0;
      if (i.UF_OBORUD_ZAIM === "") i.UF_OBORUD_ZAIM = 0;
      let sum =
        parseInt(i.UF_ZARPLATA_ZAIM) +
        parseInt(i.UF_JOB_ZAIM) +
        parseInt(i.UF_MATERIAL_ZAIM) +
        parseInt(i.UF_OBORUD_ZAIM);

      this.project.BUDGET.items[item].UF_ITOGO_ZAIM = sum;
      return sum;
    },
    calcBudgetRowSofin(item) {
      let i = this.project.BUDGET.items[item];
      if (i.UF_ZARPLATA_SOFIN === "") i.UF_ZARPLATA_SOFIN = 0;
      if (i.UF_JOB_SOFIN === "") i.UF_JOB_SOFIN = 0;
      if (i.UF_MATERIAL_SOFIN === "") i.UF_MATERIAL_SOFIN = 0;
      if (i.UF_OBORUD_SOFIN === "") i.UF_OBORUD_SOFIN = 0;
      let sum =
        parseInt(i.UF_ZARPLATA_SOFIN) +
        parseInt(i.UF_JOB_SOFIN) +
        parseInt(i.UF_MATERIAL_SOFIN) +
        parseInt(i.UF_OBORUD_SOFIN);

      this.project.BUDGET.items[item].UF_ITOGO_SOFIN = sum;
      return sum;
    },
    calcBudgetYearsRowZaim(item, k) {
      let i = this.project.BUDGET_YEAR.items[item][k];
      let sum =
        parseInt(i.UF_ZARPLATA_ZAIM) +
        parseInt(i.UF_JOB_ZAIM) +
        parseInt(i.UF_MATERIAL_ZAIM) +
        parseInt(i.UF_OBORUD_ZAIM);

      this.project.BUDGET_YEAR.items[item][k].UF_ITOGO_ZAIM = sum;
      return sum;
    },
    calcBudgetYearsRowSofin(item, k) {
      let i = this.project.BUDGET_YEAR.items[item][k];
      let sum =
        parseInt(i.UF_ZARPLATA_SOFIN) +
        parseInt(i.UF_JOB_SOFIN) +
        parseInt(i.UF_MATERIAL_SOFIN) +
        parseInt(i.UF_OBORUD_SOFIN);

      this.project.BUDGET_YEAR.items[item][k].UF_ITOGO_SOFIN = sum;
      return sum;
    },
    calcBudgetSum(field) {
      let sum = 0;
      Object.keys(this.project.BUDGET.items).map(function(objectKey) {
        sum += parseInt(this.project.BUDGET.items[objectKey][field]);
      }, this);
      return sum;
    },
    calcBudgetYearsSum(field) {
      let sum = 0;
      Object.keys(this.project.BUDGET_YEAR.items).map(function(objectKey) {
        sum += parseInt(this.project.BUDGET_YEAR.items[objectKey][0][field]);
        if (this.project.BUDGET_YEAR.items[objectKey].length > 1) {
          sum += parseInt(this.project.BUDGET_YEAR.items[objectKey][1][field]);
        }
      }, this);
      return sum;
    },
    calcArticlesSum(articles, field) {
      let sum = 0;
      articles.forEach(function(article) {
        sum += parseInt(
          this.project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID][field]
        );
      }, this);
      return sum;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    budgetIndex(i) {
      let budgetIndex;
      let k = Object.keys(this.project.BUDGET.BUDGET_ARTICLE_ID);
      for (budgetIndex = 0; budgetIndex < k.length; budgetIndex++) {
        if (k[budgetIndex] == i) {
          break;
        }
      }
      return budgetIndex + 1;
    },
    calcSourceSum() {
      let sum = 0;
      this.directory.tree_vid_financing_other_sources[1].CHILD.forEach(function(
        s
      ) {
        this.project.OTHER_SOURCE_FINANCE.items_v3.forEach(function(item) {
          if (
            s.ID === item.UF_OTHER_SOURCE_ID &&
            s.CODE !== "all_sofinance_v3" &&
            s.CODE !== "investor_v3" &&
            s.CODE !== "investor_not_last_2year_v3"
          ) {
            let ss = parseInt(item.UF_SUM_ALL);
            if (ss > 0) {
              sum += ss;
            }
          }
        }, this);
      },
      this);
      return sum;
    },
    calcSourceChildSum(childs) {
      let sum = 0;
      childs.forEach(function(child) {
        this.project.OTHER_SOURCE_FINANCE.items_v3.forEach(function(item) {
          if (child.ID == item.UF_OTHER_SOURCE_ID) {
            let s = parseInt(item.UF_VALUE);
            if (s > 0) {
              sum += s;
            }
          }
        }, this);
      }, this);
      return sum;
    },
    inSourceList(sourceId) {
      let n = false;
      this.project.OTHER_SOURCE_FINANCE.UF_OTHER_SOURCE_ID.forEach(function(
        id
      ) {
        if (sourceId == id) {
          n = true;
        }
      },
      this);
      return n;
    },
    isFirstSource(sourceId, index) {
      let sd = null;
      this.project.OTHER_SOURCE_FINANCE.items_v3.forEach(function(item, k) {
        if (sourceId == item.UF_OTHER_SOURCE_ID && sd === null) {
          sd = k;
        }
      }, this);
      return sd === index;
    },
    addSourceItem(sourceId) {
      this.project.OTHER_SOURCE_FINANCE.items.push({
        UF_COUNTRY_ID: this.findRussia(),
        UF_OTHER_SOURCE_ID: sourceId,
        UF_PROJECT_ID: this.project.ID,
        UF_SOURCE: "",
        UF_TARGET: "",
        UF_VALUE: "",
        UF_YEAR: ""
      });
    },
    hasOtherSourceFinanceError(id, field) {
      if (
        typeof this.$parent.$parent.otherSourceFinanceErrors[id] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.otherSourceFinanceErrors[id][field] !==
          "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    removeOtherSourceFinanceError(id) {
      if (
        typeof this.$parent.$parent.otherSourceFinanceErrors[id] !== "undefined"
      ) {
        Vue.delete(this.$parent.$parent.otherSourceFinanceErrors, id);
      }
      return false;
    },
    calcSumAllYear(item) {
      let sum = 0;
      if (item.UF_LAST2_YEAR > 0) {
        sum += parseInt(item.UF_LAST2_YEAR);
      }
      if (item.UF_LAST_YEAR > 0) {
        sum += parseInt(item.UF_LAST_YEAR);
      }
      if (item.UF_CURRENT_YEAR > 0) {
        sum += parseInt(item.UF_CURRENT_YEAR);
      }
      item.UF_ALL_YEAR = sum;
      return sum;
    },
    calcSumSofinance(item) {
      let sum = this.calcSumAllYear(item);
      if (item.UF_SOFINANCE_ALL > 0) {
        sum += parseInt(item.UF_SOFINANCE_ALL);
      }
      item.UF_SUM_ALL = sum;
      return sum;
    },
    calcAllSumSofinance() {
      let sum = {
        UF_CURRENT_YEAR: 0,
        UF_LAST2_YEAR: 0,
        UF_LAST_YEAR: 0,
        UF_SOFINANCE_ALL: 0,
        UF_SOFINANCE_6MONTHS: 0,
        UF_SUM_ALL: 0,
        UF_ALL_YEAR: 0
      };

      this.directory.tree_vid_financing_other_sources[1].CHILD.forEach(function(
        s
      ) {
        this.project.OTHER_SOURCE_FINANCE.items_v3.forEach(function(item) {
          if (
            s.ID === item.UF_OTHER_SOURCE_ID &&
            s.CODE !== "all_sofinance_v3" &&
            s.CODE !== "fond" &&
            s.CODE !== "regfond"
          ) {
            if (item.UF_ALL_YEAR > 0) {
              sum.UF_ALL_YEAR = sum.UF_ALL_YEAR + parseInt(item.UF_ALL_YEAR);
            }
            if (item.UF_CURRENT_YEAR > 0) {
              sum.UF_CURRENT_YEAR += parseInt(item.UF_CURRENT_YEAR);
            }
            if (item.UF_LAST2_YEAR > 0) {
              sum.UF_LAST2_YEAR =
                sum.UF_LAST2_YEAR + parseInt(item.UF_LAST2_YEAR);
            }
            if (item.UF_LAST_YEAR > 0) {
              sum.UF_LAST_YEAR = sum.UF_LAST_YEAR + parseInt(item.UF_LAST_YEAR);
            }
            if (item.UF_SOFINANCE_ALL > 0) {
              sum.UF_SOFINANCE_ALL =
                sum.UF_SOFINANCE_ALL + parseInt(item.UF_SOFINANCE_ALL);
            }
            if (item.UF_SOFINANCE_6MONTHS > 0) {
              sum.UF_SOFINANCE_6MONTHS =
                sum.UF_SOFINANCE_6MONTHS + parseInt(item.UF_SOFINANCE_6MONTHS);
            }
            if (item.UF_SUM_ALL > 0) {
              sum.UF_SUM_ALL = sum.UF_SUM_ALL + parseInt(item.UF_SUM_ALL);
            }
          }
        }, this);
      },
      this);
      return sum;
    },
    year() {
      return this.project.OTHER_SOURCE_FINANCE.yearEnd;
    },
    handleScroll: function(evt, el) {
      if (window.scrollY > 100) {
        if (el.classList.contains("table-top-bd")) {
          el.classList.add("table-top-bd_fix");
        }
      } else {
        if (el.classList.contains("table-top-bd")) {
          el.classList.remove("table-top-bd_fix");
        }
      }
    }
  },
  directives: {
    scroll: {
      // определение директивы
      inserted: function(el, binding) {
        let f = function(evt) {
          if (binding.value(evt, el)) {
            window.removeEventListener("scroll", f);
          }
        };
        window.addEventListener("scroll", f);
      }
    }
  },
  computed: {
    budgetYears() {
      let years = [];
      for (
        let i = this.project.BUDGET_YEAR.yearStart;
        i <= this.project.BUDGET_YEAR.yearEnd;
        i++
      ) {
        years.push(i);
      }
      return years;
    },
    isResumeCoordinated() {
      const list = this.project && this.project.COORDINATIONS;
      if (!Array.isArray(list)) {
        return false;
      }
      return list.some(
        el =>
          el &&
          el.UF_TYPE_PAGE === "rezume_10_01" &&
          (el.UF_IS_COORDINATION == 1 || el.UF_IS_COORDINATION === true)
      );
    },
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
